<template>

   <b-modal
    v-model="localShowModal"
    @input="$emit('update:isShowModal', $event)"
    size="xl"
    title="Paket Yönetimi"
    hide-footer
    @hide="checkBeforeClose"
  >
        <!-- Tab Navigation -->
        <b-tabs content-class="mt-3">
            <!-- Paket Bilgileri Tab -->
            <b-tab title="Paket Bilgileri" active>
                <b-card>
                    <h5 class="mb-3">Paket Bilgileri Güncelle</h5>
                    <b-row>
                        <b-col md="4" v-for="(plan, index) in editablePlans" :key="index">
                            <b-card class="mb-3">
                                <h6>{{ plan.name }}</h6>
                                <b-form @submit.prevent="updatePackage(plan)">
                                    <b-form-group label="Paket Adı">
                                        <b-form-input 
                                            v-model="plan.name" 
                                            size="sm"
                                        />
                                    </b-form-group>

                                    <b-form-group label="Açıklama">
                                        <b-form-textarea 
                                            v-model="plan.description" 
                                            size="sm"
                                            rows="3"
                                        />
                                    </b-form-group>

                                    <b-form-group label="Aylık Fiyat (₺)">
                                        <b-form-input 
                                            v-model="plan.price_monthly" 
                                            type="number" 
                                            step="0.01"
                                            size="sm"
                                        />
                                    </b-form-group>

                                    <b-form-group label="Yıllık Fiyat (₺)">
                                        <b-form-input 
                                            v-model="plan.price_annual" 
                                            type="number" 
                                            step="0.01"
                                            size="sm"
                                        />
                                    </b-form-group>

                                    <b-button type="submit" variant="success" size="sm" class="w-100">
                                        Paketi Güncelle
                                    </b-button>
                                </b-form>
                            </b-card>
                        </b-col>
                    </b-row>
                </b-card>
            </b-tab>

            <!-- Özellikler Tab -->
            <b-tab title="Özellikler">
                <b-card>
                    <b-card-text class="text-danger">
                        Boş bırakmanız durumunda özellik sınırsız/ücretsiz olarak kabul edilecektir.
                    </b-card-text>
                </b-card>
                <div v-for="category in featureData" :key="category.id" class="mb-4">
                    <h5 class="mb-2">{{ category.title }}</h5>
                    <b-table :items="category.features" :fields="fields" bordered small responsive="sm">
                    <template #cell(feature_name)="data">
                        {{ data.item.feature_name }}
                    </template>

                    <template #cell(plan1_value)="data">
                        <template v-if="data.item.type === 'boolean'">
                            <b-form-select
                            v-model="data.item.plan1_value"
                            :options="[
                                { value: 1, text: 'Var' },
                                { value: 0, text: 'Yok' }
                            ]"
                            size="sm"
                            />
                        </template>
                        <template v-else>
                            <b-form-input
                            v-model="data.item.plan1_value"
                            :type="data.item.type === 'day' || data.item.type === 'number' ? 'number' : 'text'"
                            placeholder="Ücretsiz/Sınırsız"
                            size="sm"
                            />
                        </template>
                    </template>

                    <template #cell(plan2_value)="data">
                        <template v-if="data.item.type === 'boolean'">
                            <b-form-select
                            v-model="data.item.plan2_value"
                            :options="[
                                { value: 1, text: 'Var' },
                                { value: 0, text: 'Yok' }
                            ]"
                            size="sm"
                            />
                        </template>
                        <template v-else>
                            <b-form-input
                            v-model="data.item.plan2_value"
                            :type="data.item.type === 'day' || data.item.type === 'number' ? 'number' : 'text'"
                            placeholder="Ücretsiz/Sınırsız"
                            size="sm"
                            />
                        </template>
                    </template>

                    <template #cell(plan3_value)="data">
                        <template v-if="data.item.type === 'boolean'">
                            <b-form-select
                            v-model="data.item.plan3_value"
                            :options="[
                                { value: 1, text: 'Var' },
                                { value: 0, text: 'Yok' }
                            ]"
                            size="sm"
                            />
                        </template>
                        <template v-else>
                            <b-form-input
                            v-model="data.item.plan3_value"
                            :type="data.item.type === 'day' || data.item.type === 'number' ? 'number' : 'text'"
                            placeholder="Ücretsiz/Sınırsız"
                            size="sm"
                            />
                        </template>
                    </template>

                    <template #cell(action)="data">
                        <b-button variant="success" size="sm" @click="saveChanges(data.item)">Kaydet</b-button>
                    </template>
                    </b-table>
                </div>
            </b-tab>
        </b-tabs>

    </b-modal>

</template>

<script>
import {
  BButton, BBadge,
  BTable,
  BFormInput,
  BCardText,
  BRow,
  BCol,
  BCard,
  BForm,
  BTab,
  BTabs,
  BFormGroup,
  BFormTextarea,
  BFormSelect,
} from 'bootstrap-vue'
/* eslint-disable global-require */

import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BButton,
    BCardText,
    BRow,
    BCol,
    BCard,
    BBadge,
    BTable,
    BFormInput,
    BForm,
    BFormInput,
    BTab,
    BTabs,
    BFormGroup,
    BFormTextarea,
    BFormSelect
  },
  directives: {
    Ripple,
  },
  props: {
    isShowModal: {
      type: Boolean,
      default: false
    },
    featureData: {
        type: Array,
        default:[]
    },
    editablePlans: {
        type: Array,
        default:[]
    }
  },
  data() {
    return {
      featureDataOrj: [],
      localShowModal: this.isShowModal,
      fields: [
        { key: 'feature_name', label: 'Özellik' },
        { key: 'plan1_value', label: 'Plan 1' },
        { key: 'plan2_value', label: 'Plan 2' },
        { key: 'plan3_value', label: 'Plan 3' },
        { key: 'action', label: 'İşlem' }
    ]
    }
  },
  created() {
    this.featureDataOrj= JSON.parse(JSON.stringify(this.featureData))
  },
  computed: {
  },
  methods: {
    checkBeforeClose() {
      if (this.featureDataOrj.length > 0 && JSON.stringify(this.featureData) !== JSON.stringify(this.featureDataOrj)) {
        this.$bvModal.msgBoxConfirm('Değişiklikler kaydedilmedi. Kapatmak istediğinize emin misiniz?', {
          title: 'Uyarı',
          okTitle: 'Evet',
          cancelTitle: 'Hayır',
          centered: true,
        }).then((value) => {
          if (!value) {
            this.$emit('update:is-show-modal', false);
          }
        })
      }
    },
    // Paket bilgilerini güncelle
    async updatePackage(plan) {
        try {
            const response = await this.$http.put(`/manage/packages/${plan.id}`, {
                name: plan.name,
                description: plan.description,
                price_monthly: plan.price_monthly,
                price_annual: plan.price_annual,
                status: plan.status,
                id: plan.id
            });

            if (response.data.success) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Başarılı',
                        text: 'Paket bilgileri güncellendi',
                        icon: 'CheckIcon',
                        variant: 'success',
                    },
                });
            this.$emit('update-plans')
            this.$emit('update:is-show-modal', false);
            }
        } catch (error) {
            console.error('Paket güncelleme hatası:', error);
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: 'Hata',
                    text: 'Paket güncellenemedi',
                    icon: 'XIcon',
                    variant: 'danger',
                },
            });
        }
    },
    saveChanges(feature) {
        this.$http.put('/manage/package-features/'+feature.id, feature).then(() => {
            this.$emit('update:is-show-modal', false);
            this.$emit('update-plans')
        this.$bvToast.toast('Değişiklikler kaydedildi.', {
            title: 'Başarılı',
            variant: 'success',
            solid: true
        })
        })
    },
    yearPrice(price) {
        return this.priceFormat(parseInt(price, 10) * 12);
    },
  },
  watch: {
    isShowModal(val) {
      this.localShowModal = val
    },
    localShowModal(val) {
        this.$emit('update:is-show-modal', val);
    },
  },
}
/* eslint-disable global-require */
</script>